import {Button, Divider, Input, message, Row, Col} from 'antd';
import {useState} from 'react';
import {setAddressForBuyer, setEmailAddressForBuyer, setNewBuyer, setPhoneNumberForBuyer} from "../../api/Api";


export const NewBuyerInput = ({onApiFail, onRefresh, props}) => {
    // buyer profile state
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [company, setCompany] = useState("");
    const [license, setLicense] = useState("");
    const [messageApi, contextHolder] = message.useMessage();

    // address state
    const [streetAddress, setStreetAddress] = useState("");
    const [streetAddressLine2, setStreetAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [addressDescription, setAddressDescription] = useState("");

    // email state
    const [email, setEmail] = useState("");
    const [emailDescription, setEmailDescription] = useState("");

    // phone number state
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneDescription, setPhoneDescription] = useState("");

    const onNameChange = (e) => {
        setFirstname(e.target.value);
    }

    const onLastNameChange = (e) => {
        setLastname(e.target.value);
    }

    const onCompanyChange = (e) => {
        setCompany(e.target.value);
    }

    const onLicenseChange = (e) => {
        setLicense(e.target.value);
    }

    const onFail = (e) => {
        if (e.status === 401) {
            if (onApiFail) {
                onApiFail();
            }
        }
    }

    const onSubmit = () => {
        if (firstname === "") {
            return;
        }

        setNewBuyer(firstname, lastname, company, license).then(result => {
            const buyerId = result;
            console.log(`set new buyer succeeded ${result}`);
            if (streetAddress !== "") {
                setAddressForBuyer(buyerId, streetAddress, streetAddressLine2, city, state, country, postalCode, addressDescription, true).then(r => {
                    console.log(`set address succeeded`);
                }).catch(e => {
                    console.log(`set address failed ${e}`)
                });
            }
            if (email !== "") {
                setEmailAddressForBuyer(buyerId, email, emailDescription, true).then(r => {
                    console.log(`set email succeeded`);
                }).catch(e => {
                    console.log(`set email failed ${e}`)
                })
            }
            if (phoneNumber !== "") {
                setPhoneNumberForBuyer(buyerId, phoneNumber, phoneDescription, true).then(r => {
                    console.log(`set phone number succeeded`);
                }).catch(e => {
                    console.log(`set phone number failed ${e}`)
                })
            }
            if (onRefresh) {
                onRefresh();
                clearInputs();
                messageApi.open({
                    type: 'success',
                    content: 'Buyer Added Successfully',
                });
            }
        }).catch(e => {
            onFail(e);
        })
    }

    const onStreetAddressChange = (e) => {
        setStreetAddress(e.target.value);
    }

    const onStreetAddressLine2Change = (e) => {
        setStreetAddressLine2(e.target.value);
    }

    const onCityChange = (e) => {
        setCity(e.target.value);
    }

    const onStateChange = (e) => {
        setState(e.target.value);
    }

    const onCountryChange = (e) => {
        setCountry(e.target.value);
    }

    const onPostalCodeChange = (e) => {
        setPostalCode(e.target.value);
    }

    const onAddressDescriptionChange = (e) => {
        setAddressDescription(e.target.value);
    }

    const onEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const onEmailDescriptionChange = (e) => {
        setEmailDescription(e.target.value);
    }

    const onPhoneNumberChange = (e) => {
        setPhoneNumber(e.target.value);
    }

    const onPhoneDescriptionChange = (e) => {
        setPhoneDescription(e.target.value);
    }

    const clearInputs = () => {
        setFirstname("");
        setLastname("");
        setLicense("");
        setCompany("");
        setStreetAddress("");
        setStreetAddressLine2("");
        setCity("");
        setState("");
        setCountry("");
        setPostalCode("");
        setAddressDescription("");
        setEmail("");
        setEmailDescription("");
        setPhoneNumber("");
        setPhoneDescription("");
    }


    const spanLength = 12;

    return (
    <div>
        <div>{contextHolder}</div>
    <div >
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><div><Input onChange={onNameChange} placeholder={'First Name'} value={firstname} /></div></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><div><Input onChange={onLastNameChange} placeholder={'Last Name'} value={lastname} /></div></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><div><Input onChange={onCompanyChange} placeholder={'Company'} value={company} /></div></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><div><Input onChange={onLicenseChange} placeholder={'License'} value={license} /></div></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><div><Button onClick={onSubmit}>Submit</Button></div></Col>
        </Row>
        <Divider orientation={'left'}>Address</Divider>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Street"} onChange={onStreetAddressChange} value={streetAddress}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Street2"} onChange={onStreetAddressLine2Change} value={streetAddressLine2}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"City"} onChange={onCityChange} value={city}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"State"} onChange={onStateChange} value={state}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Postal Code"} onChange={onPostalCodeChange} value={postalCode}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Country"} onChange={onCountryChange} value={country}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Description"} onChange={onAddressDescriptionChange} value={addressDescription}></Input></Col>
        </Row>
        <Divider orientation={'left'}>Email</Divider>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Email"} onChange={onEmailChange} value={email}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Email Description"} onChange={onEmailDescriptionChange} value={emailDescription}></Input></Col>
        </Row>
        <Divider orientation={'left'}>Phone</Divider>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Phone Number"} onChange={onPhoneNumberChange} value={phoneNumber}/></Col>
        </Row>
        <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={spanLength}><Input placeholder={"Phone Description"} onChange={onPhoneDescriptionChange} value={phoneDescription}></Input></Col>
        </Row>
        <Row>
            <Col span={spanLength}><div><Button onClick={onSubmit}>Submit</Button></div></Col>
        </Row>
    </div>
    </div>
    )
}